import { render, staticRenderFns } from "./HoverItem.vue?vue&type=template&id=57f63352&"
import script from "./HoverItem.vue?vue&type=script&lang=js&"
export * from "./HoverItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
installComponents(component, {VHover})
